import { SET_CHOICES, SET_SUB_STEP, SET_STEP, SET_POPUP, SET_ADD_TO_CART_CHECK } from "./actionTypes";

export const setChoices = (dispatch, payload) => {
    dispatch({
        type: SET_CHOICES,
        payload,
    });
}

export const setSubStep = (dispatch, payload) => {
    dispatch({
        type: SET_SUB_STEP,
        payload
    })
}

export const setStep = (dispatch, payload) => {
    dispatch({
        type: SET_STEP,
        payload
    })
}

export const setPopup = (dispatch, payload) => {
    dispatch({
        type: SET_POPUP,
        payload
    })
}

export const setAddToCartCheck = (dispatch, payload) => {
    dispatch({
        type: SET_ADD_TO_CART_CHECK,
        payload
    })
}